import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Dialog from './Dialog';

const LayoutPlainText: React.FC = ({ children }) => {
  return (
    <>
      <Header />
        <main className="page-layout-plain-text">
          <section className="section">
            <div className="container">
              <div className="section__content">
                {children}
              </div>	
            </div>
          </section>
        </main>
      <Footer />
      <Dialog />
    </>
  );
};

export default LayoutPlainText;
